module.exports = __webpack_public_path__ + "static/fonts/CircularStd-Book.f6381a12.ttf";